import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class TizenNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    let netStatus = false;
    //let webapis = window.webapis || {};
    logger.debug('[NetworkStatus] checking Tizen...' + window.webapis);
    try {
      //let webapis = require('$WEBAPIS/webapis/webapis.js');
      netStatus = window.webapis.network.isConnectedToGateway();
      logger.debug("[NetworkStatus] Tizen isInternetConencted:" + netStatus);
    } catch (e) {
      logger.error("[NetworkStatus] isConnectedToGateway exception [" + e.code + "] name: " + e.name + " message: " + e.message);
    }

    return Promise.resolve(netStatus);
  }

}

export default TizenNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/tizen/NetworkStatus.js